export default "__VITE_ASSET__6393dd80__"